import { render, staticRenderFns } from "./CountingStockDetail.vue?vue&type=template&id=4a708b19&scoped=true&"
import script from "./CountingStockDetail.vue?vue&type=script&lang=js&"
export * from "./CountingStockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a708b19",
  null
  
)

export default component.exports